module.exports = __webpack_public_path__ + "img/RotatingNotrun.686de79a.svg";